import React from 'react';

export const AdaptiveIcon = ({
  fillColour = '#F1EEFF',
  iconColor = 'rgb(61, 61, 61)',
  size = '32',
  borderRadius = '16',
  boxShadow = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx={borderRadius}
        fill={fillColour}
        style={{
          boxShadow: boxShadow,
        }}
      />
      <g clipPath="url(#clip0_1283_7443)" color={iconColor}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 15H23C23 11.6863 20.3137 9 17 9V10C19.7614 10 22 12.2386 22 15ZM20 15H21C21 12.7909 19.2091 11 17 11V12C18.6569 12 20 13.3431 20 15ZM20.0346 19.0365L20.0355 19.0355L16.8709 15.8712L17.8456 14.8959C18.0505 14.6909 18.0504 14.3585 17.8455 14.1536C17.6404 13.9485 17.3079 13.9485 17.1029 14.1537L16.1284 15.1288L12.9641 11.9648C12.725 12.204 12.5125 12.4649 12.3288 12.743C11.7922 13.5548 11.5 14.5123 11.5 15.5C11.5 16.4543 11.7728 17.3805 12.2752 18.1743L11 22L9.5 22C9.22386 22 9 22.2239 9 22.5C9 22.7761 9.22386 23 9.5 23H22.5C22.7761 23 23 22.7761 23 22.5C23 22.2239 22.7761 22 22.5 22L16 22V20.475C16.1654 20.4916 16.3323 20.5 16.5 20.5C17.4877 20.5 18.4452 20.2078 19.257 19.6712C19.5348 19.4876 19.7956 19.2754 20.0346 19.0365ZM15 22H12L12.9823 19.0532C13.5534 19.6187 14.2468 20.0328 15 20.2697V22ZM12.5 15.5C12.5 14.7794 12.6944 14.0788 13.0543 13.4685L18.5315 18.9457C17.9212 19.3056 17.2206 19.5 16.5 19.5C15.4391 19.5 14.4217 19.0786 13.6716 18.3284C12.9214 17.5783 12.5 16.5609 12.5 15.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1283_7443">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AdaptiveTrialIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#8B74FF" />
      <g clipPath="url(#clip0_2544_18192)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 15H23C23 11.6863 20.3137 9 17 9V10C19.7614 10 22 12.2386 22 15ZM17.8454 14.1535C17.6403 13.9485 17.3078 13.9485 17.1028 14.1536L16.1284 15.1284L12.9645 11.9645C12.0268 12.9021 11.5 14.1739 11.5 15.5C11.5 16.4543 11.7728 17.3805 12.2752 18.1743L11 22H9.5C9.22386 22 9 22.2239 9 22.5C9 22.7761 9.22386 23 9.5 23H22.5C22.7761 23 23 22.7761 23 22.5C23 22.2239 22.7761 22 22.5 22H16V20.475C16.1654 20.4916 16.3323 20.5 16.5 20.5C17.8261 20.5 19.0979 19.9732 20.0355 19.0355L16.8708 15.8708L17.8454 14.8959C18.0504 14.6909 18.0504 14.3585 17.8454 14.1535ZM15 20.2697C14.2468 20.0328 13.5534 19.6187 12.9823 19.0532L12 22H15V20.2697ZM21 15H20C20 13.3431 18.6569 12 17 12V11C19.2091 11 21 12.7909 21 15Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2544_18192">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
